import React from 'react'
import { Button, Menu } from '@sencha/ext-modern'

import { showContextMenu } from './contextmenu'
import { getColumnType } from './column'

import filterTypes, { getFilterItems } from './filterItems'

const genColumnFilter = ({ selectValues = [], ...column }) => {
	let { search, filter, locale } = column
	filter = filter || filter == undefined && search && true

	const ret = {}

	if (!filter)
		return ret

	const colType = getColumnType(column)

	ret.colName = column[colType]
	filter = filter === true && [] || filter

	// column.tools : filter:['type', 'name', options], 均可省略，默认取列项类型定义(去除_)及字段名
	// 20240705: 修改为filter:['type', 'name', options, wrapProps, compProps]
	// type: '类型', 目前有	'text',	'int',	'number',	'float',	'date',	'datetime',	'select',	'combo',
	// name: '名称',
	// options: 用于select, combo, 可以不用配置而由后台根据selectFields返回selectValues以供使用，用于'date', 'datetime'则为检查的时间单位(分别默认为'D'、'm'代表到日还是到分钟)
	// wrapProps: 主要配置 minWidth, maxWidth
	// compProps: 主要用于combo，可以定义 editable(默认 true), multiSelect(默认 false), forceSelection(默认true), clearable:(默认true)
	//		注意multiSelect与forceSelection有冲突，不能同时为true，否则将会出现焦点丢失时被清空值。
	// 20250618: filter:[...] 增加 locale定义，从 column 定义中取值
	// 20200119 增加类型: 
	while (filter && Array.isArray(filter)) {
		const [type, nameProp, options, wrapProps, compProps] = filter
		const name = nameProp || column.field || column.name || column[colType]
		name && !ret.colName && (ret.colName = name)

		const typeOfFilter = type || (colType && colType.slice(1))

		if (filter.length <= 0 && !filterTypes.includes(typeOfFilter))
			break

		if (filter.length > 0 && (!name || !filterTypes.includes(typeOfFilter))) {
			console.error(`column's filter's config error, should be like ['type', 'name', options, wrapProps, compProps] : `, column)
			break
		}

		const filterProp = { name, type: typeOfFilter, options: options || selectValues[name], locale, wrapProps, compProps }
		Object.entries(filterProp).forEach(([k, v]) => v === undefined && (delete filterProp[k]))
		ret.filter = filterProp
		break
	}

	// console.log('filter:', filter)
	// console.log('ret:', ret)
	return ret
}

const hasFilterValues = (filterProp, name) => filterProp[name] && Object.keys(filterProp[name]).length


// renderFiltersButton(config.filter, config.columns, filterProp, this.handleFilterChange)
// columns.map((column, key) => renderColumn({ filter: config.filter ? [] : undefined, ...column, filterProp, onFilterChange: this.handleFilterChange }, /* `${currTabName || ''}${key}` */key, this))

export const renderFiltersButton = ({ columns, filterProp, filterChoices, onFilterChange, selectValues, ...props } = {}) => {
	const handleFilterClick = (btn, e) => {
		const position = [btn.el.getLeft(), btn.el.getBottom()]
		const menuItems = []
		let itemsCnt = 0

		for (const column of columns) {
			const { colName, filter } = genColumnFilter({ ...column, selectValues })
			if (!colName || !filter)
				continue

			const { items, count, wrapProps } = getFilterItems({ filter, filterProp, filterChoices, onFilterChange, selectValues, isGroup: true })
			itemsCnt += count
			menuItems.push({
				xtype: 'containerfield', margin: '0 20 2 0', flex: 1,
				minWidth: count > 3 && '90%' || 300,
				// maxWidth: /* items.length > 1 && 800 ||  */400,
				layout: { type: 'hbox', wrap: true, align: 'start', pack: 'start' },
				label: colName, labelAlign: 'left', labelTextAlign: 'right',
				ui: hasFilterValues(filterProp, filter.name) ? 'action' : '',
				items,
				...wrapProps
			})
		}

		menuItems.push({
			xtype: 'toolbar', shadow: false, docked: 'bottom', ui: "app-transparent-toolbar", layout: { type: 'hbox', pack: 'right' },
			items: [
				{
					xtype: 'button', text: '关闭', /* ui: 'action',  */iconCls: 'x-fa fa-check', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
					handler: btn => {
						// console.log('确定:', btn)
						btn.up('menu').close()
					}
				},
				{
					xtype: 'button', text: '清空', /* ui: 'action',  */iconCls: 'x-fa fa-trash-o', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
					handler: () => {
						for (let key in filterProp) { delete filterProp[key] }
						for (let key in filterChoices) { delete filterChoices[key] }
						onFilterChange && onFilterChange(filterProp)
						handleFilterClick(btn)
					}
				}
			]
		})

		const menu = [{
			xtype: 'fieldpanel', flex: 1, layout: { type: 'hbox', wrap: true }, margin: '10 0 0 10',
			maxWidth: /* itemsCnt > 20 &&  */800 /* || 400 */,
			items: menuItems
		}]

		showContextMenu(position, menu)
	}

	const haveFilters = !!columns.find(c => {
		const { filter } = genColumnFilter({ ...c, selectValues })
		return !!filter
	})

	if (haveFilters && !filterProp || !onFilterChange) {
		console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
		return null
	}


	!props.hidden && !haveFilters && (props.hidden = true)
	filterProp && (props.badgeText = Object.keys(filterProp).length)

	return <Button noLocale text='...' iconCls='x-fa fa-filter' shadow margin="0 10 0 0" ui='action' handler={handleFilterClick} {...props} />

	// return <Button text='...' iconCls='x-fa fa-filter' shadow margin="0 20 0 0" ui='action' arrow={false} {...props}>
	//   <Menu autoHide={false} /* scrollable={true} */ maxHeight='90%' /* minWidth='700'  *//* width='800' *//*  maxWidth='800' */
	//     items={menu} layout={{ type: 'vbox' }} />
	// </Button>
}


export const getColumnFilterTool = (columnPar) => {
	const { filterProp, filterChoices, onFilterChange, selectValues } = columnPar
	if (!filterProp || !onFilterChange) {
		// console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
		return null
	}

	const { filter } = genColumnFilter(columnPar)
	if (!filter)
		return null
	// console.log('filter:', filter)
	// if (!filterProp || !onFilterChange) {
	//   console.error(`filterProp 或 onFilterChange 未设置，不能使用过滤: filterProp:${filterProp}, onFilterChange:${onFilterChange}`)
	//   return null
	// }

	const handleFilterClick = (column, tool, e) => {
		const position = [column.el.getLeft(), column.el.getBottom()]
		const { items, count } = getFilterItems({ filter, filterProp, filterChoices, onFilterChange, selectValues })
		// console.log('items:', items, count)
		// console.log('items:', filter, items)
		count > 2 && items.push({
			xtype: 'toolbar', shadow: false, docked: 'bottom', ui: "app-transparent-toolbar", layout: { type: 'hbox', pack: 'right' },
			items: [{
				xtype: 'button', text: '清空', /* ui: 'action',  */iconCls: 'x-fa fa-trash-o', style: { padding: '1px 2px 1px 1px' }, margin: '0 20 0 0',
				handler: () => {
					if (!filterProp[filter.name])
						return
					delete filterProp[filter.name]
					delete filterChoices[filter.name]
					onFilterChange && onFilterChange(filterProp)
					handleFilterClick(column)
				}
			}]
		})
		const menu = [{
			xtype: 'fieldpanel', flex: 1, layout: { type: 'hbox', wrap: true }, margin: '10 0 0 10',
			maxWidth: count > 20 && 800 || 400,
			items,
		}]

		showContextMenu(position, menu)
	}


	if (filter)
		return {
			iconCls: 'x-fa fa-filter', zone: 'head',/*  filter,  */
			ui: hasFilterValues(filterProp, filter.name) ? 'action' : '',
			handler: handleFilterClick
		}

	return null
}

